module.exports = __webpack_public_path__ + "static/20-aerial-views-v-1a7b8eb0aa2e021bca5781480664d294.jpeg";